module.exports = __webpack_public_path__ + "static/img/1.f57cffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-terrestre-carga/1.png
// module id = UfnR
// module chunks = 0